import { render, staticRenderFns } from "./DeliveryTime.vue?vue&type=template&id=4615860a&lang=pug&"
import script from "./DeliveryTime.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTime.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryTime.vue?vue&type=style&index=0&id=4615860a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports